(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83509,49105],{

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 57149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_PlainTextSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Button/index.jsx + 1 modules
var Button = __webpack_require__(49105);
// EXTERNAL MODULE: ./UI/components/Figures/index.jsx + 3 modules
var Figures = __webpack_require__(84486);
// EXTERNAL MODULE: ./UI/components/CallToAction/index.jsx + 1 modules
var CallToAction = __webpack_require__(49617);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/PlainTextSection/utils/useSectionProps.js





/* harmony default export */ function useSectionProps(_param) {
    var section = _param.section, type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "section",
        "type"
    ]);
    var ref = (0,helper/* getDocumentFields */.OA)(section, [
        "title",
        "description",
        "subtitle",
        "view",
        "contentModules",
        "background", 
    ]), title = ref.title, description = ref.description, subtitle = ref.subtitle, view = ref.view, contentModules = ref.contentModules, background = ref.background;
    var ref1 = (0,react.useState)(false), isSeeMore = ref1[0], setIsSeeMore = ref1[1];
    var ref2 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", []), [
        "text",
        "hasSeeMoreButton"
    ]), text = ref2.text, hasSeeMoreButton = ref2.hasSeeMoreButton;
    var backgroundImageUrl = background ? (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(background), {
        fm: "png"
    }) : null;
    var figuresData = get_default()(contentModules, "[0]", {});
    var ctaLink = get_default()(contentModules, "[1]", {});
    var onClickMoreButton = (0,react.useCallback)(function() {
        setIsSeeMore(!isSeeMore);
    }, [
        isSeeMore
    ]);
    return (0,_object_spread/* default */.Z)({
        title: title,
        description: description,
        subtitle: subtitle,
        view: view,
        type: type,
        text: text,
        hasSeeMoreButton: hasSeeMoreButton,
        onClickMoreButton: onClickMoreButton,
        isSeeMore: isSeeMore,
        figuresData: Object.keys(figuresData).length ? figuresData : null,
        ctaLink: ctaLink,
        backgroundImageUrl: backgroundImageUrl
    }, props);
};

// EXTERNAL MODULE: ./UI/sections/PlainTextSection/styles.module.scss
var styles_module = __webpack_require__(59877);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/PlainTextSection/utils/data.js

var CTA_AS_FIGURE = [
    constants/* ROUTES.webinarLLM.slug */.y2.webinarLLM.slug,
    constants/* ROUTES.webinarDeployingAgent.slug */.y2.webinarDeployingAgent.slug
];

;// CONCATENATED MODULE: ./UI/sections/PlainTextSection/index.jsx
















var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var ContentfulParser = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 92870));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92870)
            ];
        }
    }
});
var PlainTextSection = function(props) {
    var ref = useSectionProps(props), title = ref.title, description = ref.description, subtitle = ref.subtitle, view = ref.view, type = ref.type, text = ref.text, hasSeeMoreButton = ref.hasSeeMoreButton, onClickMoreButton = ref.onClickMoreButton, isSeeMore = ref.isSeeMore, figuresData = ref.figuresData, handleOnCTAClick = ref.handleOnCTAClick, ctaLink = ref.ctaLink, backgroundImageUrl = ref.backgroundImageUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((styles_module_default()).plainText, (styles_module_default())[type], (styles_module_default())[view]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).textContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                            title: title,
                            subtitle: subtitle,
                            description: description,
                            titleStyle: (styles_module_default()).titleStyle
                        }),
                        text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((styles_module_default()).text, (0,_define_property/* default */.Z)({}, (styles_module_default()).seeMore, isSeeMore)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser, {
                                    document: text
                                })
                            })
                        })),
                        hasSeeMoreButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            className: (styles_module_default()).seeMoreButton,
                            onClick: onClickMoreButton,
                            children: "See more"
                        }),
                        figuresData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Figures/* Figures */.N, {
                            type: type,
                            figuresData: figuresData
                        }),
                        !!Object.keys(ctaLink).length && CTA_AS_FIGURE.includes(type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                            transitionDelay: 50,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction["default"], {
                                data: ctaLink,
                                handleOnClick: handleOnCTAClick,
                                className: (styles_module_default()).callToAction
                            })
                        }))
                    ]
                }),
                backgroundImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).backgroundImageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        transitionDelay: 50
                    }, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                className: (styles_module_default()).backgroundImage,
                                src: backgroundImageUrl,
                                alt: title
                            })
                        })
                    }))
                }),
                !!Object.keys(ctaLink).length && !CTA_AS_FIGURE.includes(type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction["default"], {
                        data: ctaLink,
                        handleOnClick: handleOnCTAClick,
                        className: (styles_module_default()).callToAction
                    })
                }))
            ]
        })
    });
};
PlainTextSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_PlainTextSection = (PlainTextSection);


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 59877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__GdvgK","cards":"styles_cards__7F5J_","imageWrapper":"styles_imageWrapper__Z6gvL","typeTitle":"styles_typeTitle__JbUBY","greySection":"styles_greySection__Yq0To","callToAction":"styles_callToAction__QHomo","threeColumnsCards":"styles_threeColumnsCards__r37Z4","twoColumnsCards":"styles_twoColumnsCards__JABZN","textContent":"styles_textContent__j1eqQ","plainText":"styles_plainText__sK1_z","contentWrapper":"styles_contentWrapper__NEN_m","text":"styles_text__df3nW","pageImage":"styles_pageImage__QhngB","seeMoreButton":"styles_seeMoreButton___OGiE","seeMore":"styles_seeMore__H4Rka","devops-development-services":"styles_devops-development-services__7Nh7b","titleStyle":"styles_titleStyle__lrVd4","data-science-development-company":"styles_data-science-development-company__P5ShB","penetration-testing":"styles_penetration-testing__v6N1w","firstSectionView":"styles_firstSectionView__BgT1Y","thirdSectionView":"styles_thirdSectionView__LCkoG","banking-software-development-company":"styles_banking-software-development-company__Nlkab","delivery-quality-in-yellow":"styles_delivery-quality-in-yellow__omDUq","secondSectionView":"styles_secondSectionView__evOy_","generative-ai-services":"styles_generative-ai-services__w8nb_","ai-chatbot-development-services":"styles_ai-chatbot-development-services__uEBOA","computer-vision-for-aras":"styles_computer-vision-for-aras__yhuDy","david-vs-goliath":"styles_david-vs-goliath___zDxb","backgroundImageContainer":"styles_backgroundImageContainer__xp84u","backgroundImage":"styles_backgroundImage__J__Mx","beyond-the-hype":"styles_beyond-the-hype__L_XGL","scrollText":"styles_scrollText__IXDs7","llm-use-cases-webinar":"styles_llm-use-cases-webinar__mrYPx","beyond-chatbots-webinar":"styles_beyond-chatbots-webinar__ysfaq","dmitry":"styles_dmitry__rwMIl","vlad":"styles_vlad__yXuqa","sofia":"styles_sofia__iwhVj","mikita":"styles_mikita__5o8Ny","yana":"styles_yana__vCPuX","lika":"styles_lika__NED0E","nastassia":"styles_nastassia__bYwdb","ai-assessments":"styles_ai-assessments__3dgyi"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);